<cer-form #form [panes]="panesMain">
  <ng-template #mainTemplate>
    <cer-grid
      #grid
      [formView]="formView"
      [id]="formView?.id"
      [dataParent]="true"
      [viewMetadata]="viewMetadata"
      [fieldMetadata]="fieldMetadata"
      [fieldGroupMetadata]="fieldGroupMetadata"
      [toolbarCommands]="toolbarCommands"
      [contextMenuCommands]="contextMenuCommands"
      [selectionMode]="selectionMode"
      [selectionInitial]="selectionInitial"
    ></cer-grid>
  </ng-template>
  <ng-template #rightTemplate>
    <cer-form-pane pane="right">
    </cer-form-pane>
  </ng-template>
  <ng-template #bottomTemplate>
    <cer-form-pane pane="bottom">
    </cer-form-pane>
  </ng-template>
</cer-form>
